import { Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { debounceTime, filter } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { InventarioFisicoDetalleService } from 'src/app/services/inventario-fisico-detalle.service';
import { InventarioFisicoService } from 'src/app/services/inventario-fisico.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import * as _ from 'lodash';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import Swal from 'sweetalert2';

interface IDetalleDocumento {
  rut_empresa: number;
  sucursal_codigo: number;
  inventario_fisico_codigo: number;
  producto_codigo: number;
  sku: string;
  producto_nombre: string;
  formato_codigo: string;
  formato_nombre: string;
  bodega_codigo: number;
  bodega_nombre: string;
  rubro_codigo: number;
  rubro_nombre: string;
  familia_codigo: number;
  familia_nombre: string;
  fecha_registro: string;
  cantidad_contada: number;
}

@Component({
  selector: 'app-modal-toma-inventario',
  templateUrl: './modal-toma-inventario.component.html',
  styleUrls: ['../exist-inventario-fisico.component.scss'],
  providers: [SecurityService],
})
export class ExistInventarioFisicoModalTomaInventarioComponent implements OnInit {
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  // Modales
  @ViewChild('ingresarDoc', { static: true }) modalTomaInventario: ModalDirective;
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  public rutUsuario: number;

  // Form
  formHeader: FormGroup;
  formDetails: FormGroup;
  formFooter: FormGroup;
  productoSeleccionado: any = null;
  optionsFormato: any = [];
  paginationContext: PaginationContext = new PaginationContext();
  loading: boolean = true;

  movimiento: any;
  detalleDocumento: IDetalleDocumento[];
  detalleDocumentoAll: IDetalleDocumento[];
  dejarEnCeroProdNoInv: boolean;
  estado_inventario_codigo: number;
  processing: boolean = false;
  isModalOpen: boolean = false;
  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private formatoProductoService: FormatoProductosService,
    private datesService: DatesService,
    private inventarioFisicoDetalleService: InventarioFisicoDetalleService,
    private inventarioFisicoService: InventarioFisicoService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('INVENTARIO/TOMA');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.createForms();
    this.formChangesSubscriptions();

    this.paginationContext.RecordsByPage = 10;
  }

  createForms() {
    this.formHeader = this.fb.group({
      fechaMovimiento: [null, [Validators.required]],
      observacion: [null, []],
    });
    this.formDetails = this.fb.group({
      codigo: [null, [Validators.required]],
      formato: [null, [Validators.required]],
    });
    this.formFooter = this.fb.group({
      encero: [false],
    });
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent) {
    if (this.isModalOpen) {
      this.confirmCancelOperation();
    }
  }

  confirmCancelOperation() {
    Swal.fire({
      title: `¿Esta seguro que desea cancelar la operación?`, // Cambia el mensaje aquí
      showCancelButton: true,
      confirmButtonText: 'Sí',
      confirmButtonColor: '#2bbbad',
      cancelButtonText: 'No',
      cancelButtonColor: '#A1A1A1',
      reverseButtons: true, // Invertir el orden de los botones
    }).then((result) => {
      if (result.isConfirmed) {
        //TODO: SE ABRIRA MODAL DE EDICION
        this.cancelOperation();
      }
    });
  }

  cancelOperation() {
    // Lógica para cancelar la operación o cerrar el modal
    console.log('Operación cancelada');
    // Por ejemplo, podrías ocultar el modal
    this.modalTomaInventario.hide();
    this.isModalOpen = false;
  }

  formChangesSubscriptions() {
    this.formDetails
      .get('codigo')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((codigo: string) => {
        if (!codigo) return;
        this.modalSeleccionarProducto.searchBySKU(codigo);
        this.modalSeleccionarProducto.clearLast();
      });
    this.formFooter.get('encero').valueChanges.subscribe((encero: boolean) => {
      this.dejarEnCeroProdNoInv = encero;
      //this.log('inputParams', JSON.stringify(encero))
      if (this.dejarEnCeroProdNoInv) {
        if (this.detalleDocumentoAll !== undefined)
          this.detalleDocumentoAll.forEach((detalle: any, index) => {
            if (detalle.cantidad_contada === null) detalle.cantidad_contada = 0;
            detalle.additionalInfo = {
              checked: false,
              index,
              cantidad_valid: true,
            };
          });
      } else {
        if (this.detalleDocumentoAll !== undefined)
          this.detalleDocumentoAll.forEach((detalle: any, index) => {
            if (detalle.cantidad_contada === 0) {
              detalle.cantidad_contada = null;
              if (detalle.cantidad_contada === null)
                detalle.additionalInfo = {
                  checked: false,
                  index,
                  cantidad_valid: false,
                };
            }
          });
      }
    });
  }

  load(mov) {
    this.loadInventarFisico(mov);
    this.formHeader.get('fechaMovimiento').setValue(mov.fecha_creacion);
    this.formHeader.get('observacion').setValue('');
    this.dejarEnCeroProdNoInv = false;
    this.isModalOpen = true;
    this.modalTomaInventario.show();
  }

  loadInventarFisico(mov) {
    this.movimiento = mov;
    this.estado_inventario_codigo = mov.estado_inventario_codigo;

    const { rut_empresa, sucursal_codigo, codigo } = mov;
    const inputParams = {
      entidad: {
        rut_empresa,
        sucursal_codigo,
        codigo,
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));
    this.loading = true;

    this.inventarioFisicoService.obtenerInventarFisico(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      const { detalleInventarioFisico, totalRegistros, paginaActual, totalPaginas } = respuesta;

      // this.paginationContext.RecordsCount = detalleInventarioFisico.length //totalRegistros
      // this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      // this.paginationContext.CurrentPage = 1 // paginaActual
      this.setPagination(detalleInventarioFisico);

      detalleInventarioFisico.forEach((detalle, index) => {
        delete detalle.__typename;
        if (detalle.cantidad_contada === 0) detalle.cantidad_contada = null;

        detalle.additionalInfo = {
          checked: false,
          index,
          cantidad_valid: false,
        };
      });

      this.detalleDocumentoAll = detalleInventarioFisico;
      this.showPage(1);
      this.loading = false;
    });
  }

  setPagination(detalleInventarioFisico: any[]) {
    this.paginationContext.RecordsCount = detalleInventarioFisico.length; //totalRegistros
    this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
    this.paginationContext.CurrentPage = 1; // paginaActual
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.detalleDocumento = _.slice(this.detalleDocumentoAll, start, start + this.paginationContext.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  abrirModalSeleccionarProducto() {
    this.modalSeleccionarProducto.show();
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.productoSeleccionado = _productoSeleccionado;
    this.cleanProductoSeleccionadoRelateds();
    this.formDetails.get('codigo').setValue(_productoSeleccionado.sku);
    this.formatoProductoService.GetFormatosByCodigo(this.rutEmpresa, this.productoSeleccionado.codigo, ({ mensajes, respuesta }) => {
      this.optionsFormato = respuesta.registros.map((formato) => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }));
      this.formValidatorsService.selectDefaultFormatoProducto(this.formDetails.get('formato'), this.optionsFormato);
    });
  }

  onProductoNoEncontrado() {
    this.productoSeleccionado = null;
    this.optionsFormato = [];
    this.formDetails.get('formato').setValue(null);
  }

  agregarProducto() {
    let valid = this.formValidatorsService.validate(this.formDetails);
    if (!valid) return;

    let detalle = this.detalleDocumentoAll ? _.cloneDeep(this.detalleDocumentoAll) : [];
    detalle.map((detalle: any) => {
      delete detalle.saldo_actual;
      delete detalle.additionalInfo;
    });
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        bodega_codigo: this.movimiento.bodega_codigo,
        producto_codigo: this.productoSeleccionado.codigo,
        formato_codigo: this.formDetails.get('formato').value,
      },
      detalle,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.inventarioFisicoDetalleService.agregarProductoTomaInventario(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros, totalRegistros, paginaActual, totalPaginas } = respuesta;

      registros.map((detalle, index) => {
        delete detalle.__typename;
        detalle.additionalInfo = {
          checked: false,
          index,
        };
      });

      // this.paginationContext.RecordsCount = totalRegistros
      // this.paginationContext.CurrentPage = paginaActual
      // this.paginationContext.PagesCount = totalPaginas
      this.setPagination(registros);

      this.detalleDocumentoAll = registros;
      this.detalleDocumento = registros;

      this.toastService.success('Producto agregado');
      this.productInputCleanup();
      this.showPage(this.paginationContext.PagesCount);
    });
  }

  productInputCleanup() {
    this.formValidatorsService.reset(this.formDetails);
    this.productoSeleccionado = null;
    this.optionsFormato = [];
  }

  // checkAllChange({ checked }) {
  //   this.detalleDocumento.forEach((detalle: any) => { detalle.additionalInfo.checked = checked })
  // }

  // checkDetalle({ index }) {
  //   const selected: any = this.detalleDocumento.filter((detalle: any) => detalle.additionalInfo.index === index)[0]
  //   selected.additionalInfo.checked = !selected.additionalInfo.checked
  // }

  // eliminarProducto(index: number) {
  //   this.detalleDocumento = this.detalleDocumento.filter((detalle: any) => detalle.additionalInfo.index !== index)
  // }

  // eliminarProductosSeleccionados() {
  //   this.detalleDocumento = this.detalleDocumento.filter((detalle: any) => !detalle.additionalInfo.checked)
  // }

  onCantidadChange(doc, value: string): void {
    const selected: any = this.detalleDocumentoAll.filter((detalle: any) => detalle.additionalInfo.index === doc.additionalInfo.index)[0];
    selected.cantidad_contada = Number(value);

    selected.additionalInfo.cantidad_valid = !isNaN(selected.cantidad_contada) && selected.cantidad_contada >= 0;
  }

  cleanProductoSeleccionadoRelateds() {
    this.optionsFormato = [];
    this.formDetails.get('formato').setValue(null);
    this.formDetails.get('formato').markAsPristine();
    this.formDetails.get('formato').markAsUntouched();
  }

  guardar() {
    let valid = this.formValidatorsService.validate(this.formHeader);

    // Lógica para guardar los cambios
    this.dejarEnCeroProdNoInv = true;
    if (this.dejarEnCeroProdNoInv && this.detalleDocumentoAll !== undefined) {
      this.detalleDocumentoAll.map((detalle: any, index) => {
        if (detalle.cantidad_contada == null || detalle.cantidad_contada == 0) {
          detalle.cantidad_contada = 0;
        }
        detalle.additionalInfo = {
          checked: false,
          index,
          cantidad_valid: true,
        };
      });
    }

    if (!this.detalleDocumentoAll || this.detalleDocumentoAll.length === 0) {
      this.toastService.error('Agregue producto(s)');
      valid = false;
    }

    // Validar cantidades
    const noValidos = this.detalleDocumentoAll.filter((p: any) => !p.additionalInfo.cantidad_valid);
    if (noValidos.length > 0) {
      this.toastService.error('Existen productos con cantidades no válidas');
      valid = false;
    }

    if (!valid) return;

    let detalle: any = _.cloneDeep(this.detalleDocumentoAll);
    this.processing = true;
    detalle = detalle.map((detalle: IDetalleDocumento) => ({
      producto_codigo: detalle.producto_codigo,
      formato_codigo: detalle.formato_codigo,
      cantidad_contada: detalle.cantidad_contada,
    }));
    const inputParams = {
      entidad: {
        rut_empresa: this.movimiento.rut_empresa,
        sucursal_codigo: this.movimiento.sucursal_codigo,
        codigo: this.movimiento.codigo,
        rut_usuario_responsable: this.rutUsuario,
        bodega_codigo: this.movimiento.bodega_codigo,
        observacion: this.formHeader.get('observacion').value,
        no_inventariado: this.dejarEnCeroProdNoInv,
        detalleWorkInventario: detalle,
        estado_inventario_codigo: this.estado_inventario_codigo,
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.inventarioFisicoService.guardaWorkInventarioProceso(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.processing = false;
        return;
      }

      this.onSuccess.emit();
      this.isModalOpen = false;
      this.toastService.success('Operación exitosa');
      this.processing = false;
      this.modalTomaInventario.hide();
    });
  }

  generarArchivoExcel() {
    const inputParams = {
      entidad: {
        rut_empresa: this.movimiento.rut_empresa,
        sucursal_codigo: this.movimiento.sucursal_codigo,
        codigo: this.movimiento.codigo,
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.inventarioFisicoService.excelDocTomaInventarioFisico(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { rutaArchivo } = respuesta;
      this.fileDownloadService.VerifyAndDownload(rutaArchivo);
    });
  }

  closeModal() {
    this.isModalOpen = false;
    this.modalTomaInventario.hide();
  }
}
